import {  Component, Input } from '@angular/core';
import { ProfewoOffer } from '@app/models/offerpack/ProfewoOffer';

@Component({
    selector: 'clever-profewo-mini-detail',
    templateUrl: './profewo-mini-detail.component.html',
    styleUrls: ['./profewo-mini-detail.component.scss'],
    standalone: false
})
export class ProfewoMiniDetailComponent {
    @Input() datas: ProfewoOffer;
    constructor() { }
}
